export default __webpack_public_path__ + "static/media/faild.f5d0f0b4.svg";